import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogData, ConfirmDialogResponse, DialogType } from '../../aftale/models';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmDialogComponent implements OnInit {
  type: DialogType = DialogType.Information;
  isWarning: boolean;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  ) {
    if (data.type) this.type = data.type;
    this.isWarning = this.type == 1 ? true : false;
  }

  ngOnInit(): void {}

  cancel() {
    this.dialogRef.close(false);
  }

  create() {
    const result: ConfirmDialogResponse = { confirm: true };
    this.dialogRef.close(result);
  }
}
